function normalizeMessage(message?: string | null): string {
  return (message || "").toLowerCase();
}

const GENERIC_CONNECTION_MESSAGE =
  "We couldn't start your session. Your language and level are still selected, so you can try again.";
const MICROPHONE_CONNECTION_MESSAGE =
  "We couldn't access your microphone. Allow microphone access in your browser, then try again.";
const BUSY_CONNECTION_MESSAGE =
  "Your tutor is temporarily busy. Your language and level are still selected, so please try again in a moment.";
const NETWORK_CONNECTION_MESSAGE =
  "We couldn't reach your tutor. Check your internet connection, then try again.";
export const GREETING_PLAYOUT_CONNECTION_MESSAGE =
  "Your tutor's audio didn't start. Reconnect to begin a fresh session.";
export const AGENT_DISCONNECTED_CONNECTION_MESSAGE =
  "Your tutor disconnected. Reconnect to continue in a fresh session.";

const CONNECTION_MESSAGES = new Set([
  GENERIC_CONNECTION_MESSAGE,
  MICROPHONE_CONNECTION_MESSAGE,
  BUSY_CONNECTION_MESSAGE,
  NETWORK_CONNECTION_MESSAGE,
  GREETING_PLAYOUT_CONNECTION_MESSAGE,
  AGENT_DISCONNECTED_CONNECTION_MESSAGE,
]);

export const AUDIO_MICROPHONE_PERMISSION_MESSAGE =
  "Allow microphone access in your browser settings, then try again.";
export const AUDIO_PLAYBACK_BLOCKED_MESSAGE =
  "Your browser paused the tutor's audio. Tap “Try audio again” to continue.";
const AUDIO_DEVICE_NOT_FOUND_MESSAGE =
  "We couldn't find a microphone. Check that one is connected, then try again.";
const GENERIC_AUDIO_MESSAGE =
  "We couldn't start your audio. Check your device settings, then try again.";

const AUDIO_MESSAGES = new Set([
  AUDIO_MICROPHONE_PERMISSION_MESSAGE,
  AUDIO_PLAYBACK_BLOCKED_MESSAGE,
  AUDIO_DEVICE_NOT_FOUND_MESSAGE,
  GENERIC_AUDIO_MESSAGE,
]);

export function getUserFacingConnectionFailureMessage(error?: string | null): string {
  if (error && CONNECTION_MESSAGES.has(error)) return error;
  const message = normalizeMessage(error);

  if (
    message.includes("microphone") ||
    message.includes("notallowederror") ||
    message.includes("permission denied")
  ) {
    return MICROPHONE_CONNECTION_MESSAGE;
  }

  if (
    message.includes("503") ||
    message.includes("unavailable") ||
    message.includes("capacity") ||
    message.includes("no agents")
  ) {
    return BUSY_CONNECTION_MESSAGE;
  }

  if (
    message.includes("failed to fetch") ||
    message.includes("network") ||
    message.includes("load failed") ||
    message.includes("peer connection") ||
    message.includes("ice connection")
  ) {
    return NETWORK_CONNECTION_MESSAGE;
  }

  return GENERIC_CONNECTION_MESSAGE;
}

export function getUserFacingAudioMessage(error?: string | null): string {
  if (error && AUDIO_MESSAGES.has(error)) return error;
  const message = normalizeMessage(error);

  if (
    message.includes("notallowederror") ||
    message.includes("permission denied") ||
    message.includes("microphone permission")
  ) {
    return AUDIO_MICROPHONE_PERMISSION_MESSAGE;
  }

  if (
    message.includes("playback") ||
    message.includes("hear the tutor") ||
    message.includes("browser paused")
  ) {
    return AUDIO_PLAYBACK_BLOCKED_MESSAGE;
  }

  if (message.includes("notfounderror") || message.includes("device not found")) {
    return AUDIO_DEVICE_NOT_FOUND_MESSAGE;
  }

  return GENERIC_AUDIO_MESSAGE;
}
